import { css } from 'styled-components';
import { inputAndPickerBorderStyle } from 'consts/styles/inputAndPickerBorderStyle';

export const inputStyle = css`
    padding: 9px 16px;
    ${inputAndPickerBorderStyle}
`;
